/**
 * Extracts language code out of locale
 * @param locale - example: en_US
 * @returns en
 */
export const getLanguageCodeByLocale = (locale: string): string => locale.split('_')[0] || locale;
